import React from "react";
import { Avatar, Flex, Typography } from "antd";
import { FaCircleUser } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { checkIfContactSaved } from "../../../utils";
import { RootState } from "../../../redux/store";
import CustomLoader from "../../common/UI/Loader";
import "./index.scss";

const { Text } = Typography;
const UserAvatarIcon = FaCircleUser as unknown as React.FC;

interface CallScreenProps {
  member: {
    groupName: string;
    group: string;
    accountId: string;
    registeredNumber: string;
    profileImage: string;
    fullName: string;
    joined: boolean;
    invited: boolean;
    startTalking: boolean;
    isMute: boolean;
    action: string;
  };
}

const CallMemberDetails: React.FC<CallScreenProps> = ({ member }) => {
  const { contacts } = useSelector((state: RootState) => state.contacts);
  const { callerId: callerIDvalue } = useSelector(
    (state: RootState) => state.sip
  );

  return (
    <div className="call-member-details">
      <div
        className="call-content"
      >
        <Avatar
          src={member.profileImage}
          size={120}
          icon={<UserAvatarIcon />}
          className="call-avatar"
        />

        <div className="call-info">
          <Text strong className="call-number">
            {member.registeredNumber === callerIDvalue
              ? "You"
              : checkIfContactSaved(member.registeredNumber, contacts)}
          </Text>
          {member.joined ? (
            <Text type="secondary" className="call-status">
              {member?.isMute ? "Mute" : "CONNECTED"}
            </Text>
          ) : (
            <Text type="secondary" className="call-status">
              {member.invited ? "Ringing..." : member?.isMute ? "Mute" : ""}
            </Text>
          )}
          {member.startTalking && (
            <Flex justify="center" align="center">
              <CustomLoader color="#dbe3f8" />
            </Flex>
          )}
        </div>
      </div>
    </div>
  );
};

export default CallMemberDetails;
